import React from "react";
import herbalImg from "../../assets/images/about4.jpeg";
function WhyChooseUs() {
  return (
    <>
      <section className="why-containers">
        <div className="why-contents">
          <div className="why-lefts">
            <span className="why-subtitles">Why Choose Us</span>
            <br />
            <br />
            <h2 className="why-titles">Why Choose Sankalp Ayurveda</h2>

            <p className="why-descs">
              At Sankalp Ayurveda, we blend ancient Ayurvedic wisdom with modern
              quality standards to deliver safe, effective, and natural
              healthcare solutions. Our medicines are crafted using pure herbs,
              clinically trusted formulations, and ethical manufacturing
              practices to support your long-term wellness.
            </p>
            <div className="why-pointss">
              <div className="points">
                <div className="icon-circles">✔</div>
                <div>
                  <h4>100% Natural & Herbal Ingredients</h4>
                  <p>
                    We use carefully selected herbs like Amla, Jeera, Hing,
                    Pudina, and Saunf to ensure maximum purity, safety, and
                    effectiveness without harmful chemicals.
                  </p>
                </div>
              </div>
           
              <div className="points">
                <div className="icon-circles">✔</div>
                <div>
                  <h4>Safe for Daily Use</h4>
                  <p>
                    Gentle on the body, our medicines are suitable for regular
                    consumption with minimal side effects when taken as
                    recommended.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="why-rights">
            <img src={herbalImg} alt="Herbal" />
          </div>
        </div>
      </section>
    </>
  );
}

export default WhyChooseUs;
